import apiClient from './client';

export interface AlertRule {
  id: string;
  server_id: string;
  metric: 'cpu' | 'memory' | 'disk';
  threshold: number;
  enabled: boolean;
  notify_email: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface AlertRuleCreate {
  metric: 'cpu' | 'memory' | 'disk';
  threshold: number;
  enabled?: boolean;
  notify_email?: string | null;
}

export interface AlertRuleUpdate {
  metric: 'cpu' | 'memory' | 'disk';
  threshold: number;
  enabled: boolean;
  notify_email?: string | null;
}

export interface Alert {
  id: string;
  server_id: string;
  metric: 'cpu' | 'memory' | 'disk';
  threshold: number;
  current_value: number;
  status: 'active' | 'resolved';
}

export const alertsApi = {
  listRules: (serverId: string) =>
    apiClient.get<AlertRule[]>(`/api/v1/servers/${serverId}/alert-rules`).then((r) => r.data),

  createRule: (serverId: string, data: AlertRuleCreate) =>
    apiClient.post<AlertRule>(`/api/v1/servers/${serverId}/alert-rules`, data).then((r) => r.data),

  updateRule: (serverId: string, ruleId: string, data: AlertRuleUpdate) =>
    apiClient.put<AlertRule>(`/api/v1/servers/${serverId}/alert-rules/${ruleId}`, data).then((r) => r.data),

  deleteRule: (serverId: string, ruleId: string) =>
    apiClient.delete(`/api/v1/servers/${serverId}/alert-rules/${ruleId}`),

  listActiveAlerts: (serverId?: string) => {
    const params = serverId ? { server_id: serverId } : {};
    return apiClient.get<Alert[]>('/api/v1/alerts', { params }).then((r) => r.data);
  },

  listAlertHistory: (serverId?: string) => {
    const params = serverId ? { server_id: serverId } : {};
    return apiClient.get<Alert[]>('/api/v1/alerts/history', { params }).then((r) => r.data);
  },
};
